import { inject, Injectable } from "@angular/core";
import { ApiService } from "./base-api/api.service";
import { map, Observable } from "rxjs";
import { MyProfile } from '../models/my-profile';

export interface UpdateMyProfile {
    currentRole: string;
    location: string;
    origin: string;
    education: string;
    interests: string;
    skills: string;
    bio: string;
    photoUrl: string;
    isAlumniProfilePublic: boolean;
}

@Injectable({
    providedIn: 'root',
})
export class AuthenticationApiService {
    private readonly api = inject(ApiService);

    verifyOtp(data: { userId: number; phoneNumber: string; otpCode: string }): Observable<{ verified: boolean; email?: string }> {
        return this.api.post('phone-verification/verify-otp', data);
    }

    sendOtp(data: { userId: number; phoneNumber: string }): Observable<any> {
        return this.api.post('phone-verification/request-otp', data);
    }

    confirmEmail(data: { userId: number; token: string }): Observable<any> {
        return this.api.post('authentication/confirm-email', data);
    }

    resendEmailConfirmation(userId: number): Observable<any> {
        return this.api.post('authentication/resend-confirmation', { userId });
    }

    getAuthProviders(): Observable<any[]> {
        return this.api.get('authentication/auth-providers');
    }

    getMyProfile(): Observable<MyProfile> {
        return this.api.get<{ success: boolean; data: MyProfile }>('authentication/my-profile')
            .pipe(map(response => response?.data));
    }

    /** Persists the alumni directory details (bio, photo and the public-page opt-in). */
    updateMyProfile(profile: UpdateMyProfile): Observable<MyProfile> {
        return this.api.put<{ success: boolean; data: MyProfile }>('authentication/my-profile', profile)
            .pipe(map(response => response?.data));
    }

    externalLogin(data: any): Observable<any> {
        return this.api.post('authentication/external-login', data);
    }

    register(data: {
        firstName: string;
        lastName: string;
        emailAddress: string;
        phoneNumber: string;
        identityTypeId: number;
        identityNumber: string;
        institutionId: number;
        courseId: number;
        userName: string;
        password: string;
        address: string;
    }): Observable<any> {
        return this.api.post('authentication/register', data);
    }
}
